class LocalizationForm extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
			button: this.querySelector('button'),
			panel: this.querySelector('ul'),
		};
		
		if (!this.elements.input || !this.elements.button || !this.elements.panel) {
			console.warn('LocalizationForm: Required elements not found');
			return;
		}

		this.elements.button.addEventListener('click', this.openSelector.bind(this));
		this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
		this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

		this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
	}

	hidePanel() {
		if (!this.elements.button || !this.elements.panel) return;
		
		this.elements.button.setAttribute('aria-expanded', 'false');
		this.elements.panel.setAttribute('hidden', true);
	}

	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		this.hidePanel();
		this.elements.button?.focus();
	}

	onItemClick(event) {
		event.preventDefault();
		const form = this.querySelector('form');
		const value = event.currentTarget?.dataset?.value;
		
		if (!value || !this.elements.input) return;
		
		this.elements.input.value = value;
		if (form) form.submit();
	}

	openSelector() {
		if (!this.elements.button || !this.elements.panel) return;
		
		this.elements.button.focus();
		const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';
		
		if (isExpanded) {
			this.hidePanel();
		} else {
			this.elements.panel.removeAttribute('hidden');
			this.elements.button.setAttribute('aria-expanded', 'true');
		}
	}

	closeSelector(event) {
		if (!event.relatedTarget || !this.contains(event.relatedTarget)) {
			this.hidePanel();
		}
	}
}

customElements.define('localization-form', LocalizationForm);
